class cookieUtil {

    getCookie(cookieName) {
        var name = cookieName + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');

        for (var i = 0; i < cookieArray.length; i++) {
            var cookieItem = cookieArray[i];

            while (cookieItem.charAt(0) === ' ') {
                cookieItem = cookieItem.substring(1);
            }

            if (cookieItem.indexOf(name) === 0) {
                return cookieItem.substring(name.length, cookieItem.length);
            }
        }

        return '';
    }

    setCookie(cookieName, value, days, path) {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        if (path) {
            document.cookie = cookieName + '=' + (value || '') + expires + '; path=' + path;
        } else {
            document.cookie = cookieName + '=' + (value || '') + expires + '; path=/';
        }
    }

    deleteCookie(name) {
        document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

};

const CookieUtil = new cookieUtil()
export default CookieUtil


// WEBPACK FOOTER //
// ./assets/scripts/util/cookieUtil.js